module.exports = __webpack_public_path__ + "img/02_1_2_4.428aa23a.png";